module.exports = __webpack_public_path__ + "static/media/gallery01.c7b958b4.jpg";